import { useTranslation } from 'react-i18next';
import { type DebriefStage } from '@momentum/types';
import { cn } from '@/shared/utils/utils';
import { STAGE_META } from '../../gather-facts-stage/utils/stageMeta';

interface MatchPointTabsProps {
  matchPointStages: DebriefStage[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

export function MatchPointTabs({
  matchPointStages,
  activeIndex,
  onSelect,
}: MatchPointTabsProps) {
  const { t } = useTranslation('debriefV2');

  return (
    <div className="w-full px-8 pt-5 shrink-0 bg-page-bg/80 backdrop-blur-md sticky top-0 z-10 border-b border-slate-200">
      <div className="flex items-center gap-6 w-full overflow-x-auto">
        {matchPointStages.map((stage, index) => {
          const isActive = index === activeIndex;
          const label = t(STAGE_META[stage].labelKey);
          return (
            <button
              key={`${stage}-${index}`}
              type="button"
              onClick={() => onSelect(index)}
              className={cn(
                'pb-3 border-b-2 text-sm transition-colors whitespace-nowrap',
                isActive
                  ? 'border-slate-900 text-slate-950 font-semibold'
                  : 'border-transparent text-slate-500 hover:text-slate-800 font-medium'
              )}
              aria-current={isActive ? 'true' : undefined}
            >
              {`${index + 1}. ${label}`}
            </button>
          );
        })}
      </div>
    </div>
  );
}
